import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";
import Action               from "dashboard/dist/Core/Action";
import Utils                from "dashboard/dist/Utils/Utils";

// Components
import CategoryEdit         from "./CategoryEdit";
import Main                 from "dashboard/dist/Components/Main";
import Header               from "dashboard/dist/Components/Header";
import ActionList           from "dashboard/dist/Components/ActionList";
import Content              from "dashboard/dist/Components/Content";
import Table                from "dashboard/dist/Components/Table";
import TableHead            from "dashboard/dist/Components/TableHead";
import TableBody            from "dashboard/dist/Components/TableBody";
import TableRow             from "dashboard/dist/Components/TableRow";
import TableHeader          from "dashboard/dist/Components/TableHeader";
import TableCell            from "dashboard/dist/Components/TableCell";
import TablePaging          from "dashboard/dist/Components/TablePaging";
import TableActionList      from "dashboard/dist/Components/TableActionList";
import TableAction          from "dashboard/dist/Components/TableAction";
import DeleteDialog         from "dashboard/dist/Components/DeleteDialog";

// Actions
import {
    fetchCategories, deleteCategory,
} from "Actions/Admin/Coach/CategoryActions";



/**
 * The Coach Category List
 */
class CategoryList extends React.Component {
    // The Current State
    state = {
        action : Action.get(),
        elemID : 0,
    }

    /**
     * Load the Data
     * @returns {Void}
     */
    componentDidMount() {
        this.fetch();
    }

    /**
     * Fetch the content
     * @param {Object=} params
     * @returns {Void}
     */
    fetch = (params) => {
        this.props.fetchCategories(params || this.props.data.sort);
    }



    /**
     * Starts an Action
     * @param {Object} action
     * @param {Number} elemID
     * @returns {Void}
     */
    startAction = (action, elemID) => {
        this.setState({ action, elemID });
    }

    /**
     * Ends an Action
     * @returns {Void}
     */
    endAction = () => {
        this.startAction(Action.get(), 0);
    }

    /**
     * Handles the Edit Submit
     * @returns {Void}
     */
    editElem = () => {
        this.endAction();
        this.fetch();
    }

    /**
     * Handles the Delete Submit
     * @returns {Promise}
     */
    deleteElem = async () => {
        const elemID = this.state.elemID;
        this.endAction();
        await this.props.deleteCategory(elemID);
        this.fetch();
    }



    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { action, elemID                      } = this.state;
        const { data, route                         } = this.props;
        const { canEdit, list, total, sort, loading } = data;

        const elemName = Utils.getValue(list, "coachCategoryID", elemID, "name");

        return <Main>
            <Header message="COACH_CATEGORIES_NAME" icon="coach" route={route}>
                <ActionList data={data} onAction={this.startAction} />
            </Header>
            <Content isLoading={loading}>
                <Table fetch={this.fetch} sort={sort} none="COACH_CATEGORIES_NONE_AVAILABLE">
                    <TableHead>
                        <TableHeader field="name"                 message="GENERAL_NAME"            />
                        <TableHeader field="fromConversation"     message="GENERAL_FROM"            align="center" />
                        <TableHeader field="pricePerConversation" message="GENERAL_PRICE"           align="right" />
                        <TableHeader field="priceForSchool"       message="COACH_CATEGORIES_SCHOOL" align="right" />
                        <TableHeader field="quota"                message="GENERAL_PERCENT"         align="center" />
                    </TableHead>
                    <TableBody>
                        {list.map((elem) => <TableRow key={elem.coachCategoryID} elemID={elem.coachCategoryID}>
                            <TableCell message={elem.name}                        circle={elem.statusColor} />
                            <TableCell message={elem.fromConversation}            />
                            <TableCell message={`$ ${elem.pricePerConversation}`} />
                            <TableCell message={`$ ${elem.priceForSchool}`}       />
                            <TableCell message={`${elem.quota}%`}                 />
                        </TableRow>)}
                    </TableBody>
                    <TablePaging total={total} />
                    <TableActionList onAction={this.startAction} canEdit={canEdit}>
                        <TableAction action="EDIT"   message="COACH_CATEGORIES_EDIT_TITLE"   />
                        <TableAction action="DELETE" message="COACH_CATEGORIES_DELETE_TITLE" />
                    </TableActionList>
                </Table>
            </Content>

            <CategoryEdit
                open={action.isVCE}
                elemID={elemID}
                onSubmit={this.editElem}
                onClose={this.endAction}
            />
            <DeleteDialog
                open={action.isDelete}
                title="COACH_CATEGORIES_DELETE_TITLE"
                message="COACH_CATEGORIES_DELETE_TEXT"
                content={elemName}
                onSubmit={this.deleteElem}
                onClose={this.endAction}
            />
        </Main>;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        fetchCategories : PropTypes.func.isRequired,
        deleteCategory  : PropTypes.func.isRequired,
        data            : PropTypes.object.isRequired,
        route           : PropTypes.string.isRequired,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            data : state.coachCategory,
        };
    }
}

export default connect(CategoryList.mapStateToProps, {
    fetchCategories, deleteCategory,
})(CategoryList);
